import React from 'react';

const Quote = () => (
  <div className="quote-container">
    <p className="quote">
      “What music is to the heart, mathematics is to the mind.”
    </p>
    <p className="quote">
      - Amit Kalintri, Wealth of Words
    </p>
  </div>
);

export default Quote;
